import { useTranslation } from 'react-i18next';
import { Box } from '@mui/material';

import { Text } from '~/components/ui/text';
import { Title, TITLE_TYPE } from '~/components/ui/title';
import useIsElementFitInScreenWidth from '~/hooks/useIsElementFitInScreenWidth';
import arrowImg from '~/pages/HomePage/components/qr-maker-steps/assets/arrow.webp';
import {
  StyledArrow,
  StyledCard,
  StyledCardsWrapper,
  StyledContainer,
  StyledImage,
  StyledNumber,
  StyledTextWrapper,
  StyledTitle,
  StyledWrapper,
} from '~/pages/HomePage/components/qr-maker-steps/styled';
import { COLORS } from '~/styles/colors';

import image1 from './assets/image1.webp';
import image2 from './assets/image2.webp';
import image3 from './assets/image3.webp';

const LIST = [
  {
    id: 1,
    image: image1,
    title: 'landing:howToCreateQr.step1.title',
    text: 'landing:howToCreateQr.step1.text',
    className: 'blue-gradient',
  },
  {
    id: 2,
    image: image2,
    title: 'landing:howToCreateQr.step2.title',
    text: 'landing:howToCreateQr.step2.text',
    className: 'green-gradient',
  },
  {
    id: 3,
    image: image3,
    title: 'landing:howToCreateQr.step3.title',
    text: 'landing:howToCreateQr.step3.text',
    className: 'orange-gradient',
  },
];

export default function QrMakerSteps() {
  const { t } = useTranslation();
  const { elementRef } = useIsElementFitInScreenWidth({ margin: 83 * 2 });

  return (
    <StyledWrapper>
      <StyledContainer ref={elementRef} className="customContainer">
        <StyledTitle>
          <Title center type={TITLE_TYPE.h2}>
            {t('landing:howToCreateQr.title')}
          </Title>
        </StyledTitle>
        <StyledCardsWrapper>
          {LIST.map(({ id, image, title, text, className }) => (
            <StyledCard key={id}>
              <StyledNumber>{id}</StyledNumber>
              <Box className={`gradient-section ${className}`}></Box>
              <StyledTextWrapper>
                <Text variant="h3">{t(title)}</Text>
                <Text variant="input15" sx={{ color: COLORS.grey400, textAlign: 'center' }}>
                  {t(text)}
                </Text>
              </StyledTextWrapper>
              <StyledImage src={image} alt={title} />
              {id !== 3 && <StyledArrow src={arrowImg} alt="arrow" />}
            </StyledCard>
          ))}
        </StyledCardsWrapper>
      </StyledContainer>
    </StyledWrapper>
  );
}
